// /collections/baiga/ page controller. Two responsibilities, both scoped
// to the page root so this is a no-op on every other route:
//
//  1. Masthead "Baiga Collection" letter-by-letter reveal on first paint.
//  2. Scroll-triggered reveal of [data-reveal] sections / tiles / blocks
//     via a single IntersectionObserver, unobserves after firing.
//
// Global [data-reveal] base state is defined in know-how-page.scss; the
// char reveal styles are scoped to .sentiments-collection-page in
// collection-baiga-page.scss.

export function initCollectionBaigaPage() {
	const root = document.querySelector('.sentiments-collection-page');
	if (!root) return;

	initHeadingReveal(root);
	initScrollReveal(root);
}

function initHeadingReveal(root) {
	const heading = root.querySelector('.sentiments-collection-page__heading');
	if (!heading) return;

	const text = heading.textContent.trim();
	if (!text) return;

	heading.textContent = '';
	Array.from(text).forEach((ch, i) => {
		const span = document.createElement('span');
		span.className = 'sentiments-collection-page__heading-char';
		span.setAttribute('aria-hidden', 'true');
		span.style.setProperty('--char-delay', `${i * 55}ms`);
		span.textContent = ch === ' ' ? ' ' : ch;
		heading.appendChild(span);
	});

	requestAnimationFrame(() => {
		requestAnimationFrame(() => heading.classList.add('is-revealed'));
	});
}

function initScrollReveal(root) {
	// Scope to the article root, but also catch the trailing siblings
	// (products + finale) by searching from the article's parent.
	const scope = root.parentElement || root;
	const targets = scope.querySelectorAll('[data-reveal]');
	if (!targets.length) return;

	if (typeof IntersectionObserver !== 'function') {
		targets.forEach((el) => el.classList.add('is-revealed'));
		return;
	}

	const io = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-revealed');
					io.unobserve(entry.target);
				}
			}
		},
		{ threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
	);

	targets.forEach((el) => io.observe(el));
}
